import Addition from "../../components/UKG/Mathematics/Addition";
import GreaterLessThan from "../../components/UKG/Mathematics/GreaterLessThan";
import PreMathConcepts from "../../components/UKG/Mathematics/PreMathConcepts";
import SkipPattern from "../../components/UKG/Mathematics/SkipPattern";
import PreMathConceptsMenu from "./PreMathConcepts";
import AdditionMenu from "./Addition";
import Substraction from "../../components/UKG/Mathematics/Substraction";
import SubstractionMenu from "./Substraction";
import SmallestNumber from "../../components/UKG/Mathematics/SmallestNumber";
import BiggestNumber from "../../components/UKG/Mathematics/BiggestNumber";
import DataHandling from "../../components/UKG/Mathematics/DataHandling";
import DataHandlingMenu from "./DataHandling";
import Time from "../../components/UKG/Mathematics/Time";
import TimeMenu from "./Time";
import Money from "../../components/UKG/Mathematics/Money";
import MoneyMenu from "./Money";
import Colors from "../../components/UKG/Mathematics/Colors";
import ColorsMenu from "./Colors";
import Shapes from "../../components/UKG/Mathematics/Shapes";
import ShapesMenu from "./Shapes";
import OrdinalNumbers from "../../components/UKG/Mathematics/OrdinalNumbers";
import OrdinalNumbersMenu from "./OrdinalNumbers";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/mathematics/pre-math-concepts", title: "Pre-Math Concepts", component: PreMathConcepts, subMenu: PreMathConceptsMenu},
    { url: "/ukg/mathematics/skip-counting", title: "Skip Counting", component: SkipPattern},
    { url: "/ukg/mathematics/smallest-number", title: "Smallest Number", component: SmallestNumber},
    { url: "/ukg/mathematics/biggest-number", title: "Biggest Number", component: BiggestNumber},
    { url: "/ukg/mathematics/number-comparison", title: "Number Comparison", component: GreaterLessThan},
    { url: "/ukg/mathematics/ordinal-numbers", title: "Ordinal Numbers", component: OrdinalNumbers, subMenu: OrdinalNumbersMenu},
    { url: "/ukg/mathematics/addition", title: "Addition", component: Addition, subMenu: AdditionMenu},
    { url: "/ukg/mathematics/substraction", title: "Substraction", component: Substraction, subMenu: SubstractionMenu},
    { url: "/ukg/mathematics/shapes", title: "Shapes", component: Shapes, subMenu: ShapesMenu},
    { url: "/ukg/mathematics/colors", title: "Colors", component: Colors, subMenu: ColorsMenu},
    { url: "/ukg/mathematics/money", title: "Money", component: Money, subMenu: MoneyMenu},
    { url: "/ukg/mathematics/time", title: "Time", component: Time, subMenu: TimeMenu},
    { url: "/ukg/mathematics/data-handling", title: "Data Handling", component: DataHandling, subMenu: DataHandlingMenu},
];


export default topics;